<svelte:options customElement="dst-aboservice-navigation" />

<script lang="ts">
	import { baseUrls } from '@/config.ts';
	import { register as registerClosables } from '@/lib/closable.ts';
	import { initializeNavigation, onResizeNavigation } from '@/lib/navigation.ts';
	import { closableInformElement } from '@/stores/header_store.ts';
	import { onMount } from 'svelte';

	let root;
	const baseUrl = baseUrls.abo_service;

	onMount(async () => {
		registerClosables(root, $closableInformElement);
		initializeNavigation(root);
	});
</script>

<svelte:window on:resize={onResizeNavigation} />

<div class="dst-navigation" bind:this={root}>
	<nav class="contextual" aria-label="Haupt-Navigation">
		<slot name="breadcrumb" />

		<a href="{baseUrl}/abonnements">Abonnements</a>
		<a href="{baseUrl}/bestellungen">Bestellhistorie</a>
		<div class="app--header--navigation--overflowcontainer">
			<button
				type="button"
				class="app--header--navigation--overflowtoggle"
				data-closable-target="app--header--navigation--overflow"
				aria-haspopup="true"
				aria-expanded="false">mehr…</button
			>
			<dst-flyout data-closable="app--header--navigation--overflow" data-closable-active="false">
				<div class="app--header--navigation--overflow"></div>
			</dst-flyout>
		</div>
	</nav>
</div>

<style lang="scss" global>
	@use '../../scss/DstNavigation.scss';
</style>
